export default __webpack_public_path__ + "static/media/home-2.9e0a58a7.svg";